import { Task } from '@repo/shared';
import { useParams } from '@tanstack/react-router';

import TextTranslation from '@/routes/(app)/(playground)/(text-translation)/text-translation';

const Playground = () => {
  const { task } = useParams({
    from: '/app/playground/$task',
  });

  if (task === Task.TEXT_TRANSLATION) {
    return <TextTranslation />;
  }

  return <p>Add task to playground</p>;
};

export default Playground;
